import BaseRequest from '../lib/BaseRequest'

export default class OrderRequest extends BaseRequest {

  getOrderHistory(params) {
    let url = '/orders/history';
    return this.get(url, params);
  }

  getTradeByOrder(id, params) {
    let url = '/orders/trading-histories/' + id;
    return this.get(url, params)
  }

  getTradeHistory(params) {
    let url = '/orders/trading-histories';
    return this.get(url, params)
  }

  getOrdersPending(params) {
    let url = '/orders/pending';
    return this.get(url, params);
  }
}
